import { render, staticRenderFns } from "./shippingaddress.vue?vue&type=template&id=3b21db81&scoped=true"
import script from "./shippingaddress.vue?vue&type=script&lang=js"
export * from "./shippingaddress.vue?vue&type=script&lang=js"
import style0 from "./shippingaddress.vue?vue&type=style&index=0&id=3b21db81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b21db81",
  null
  
)

export default component.exports